import { render, staticRenderFns } from "./ModifierItemAddEdit.vue?vue&type=template&id=13b3e8e7"
import script from "./ModifierItemAddEdit.vue?vue&type=script&lang=js"
export * from "./ModifierItemAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports